import { OAUTH_REDIRECT_URIS, OAUTH_CLIENT_IDS, MODULE_IDS } from './oauth.constants'

export type OAuthConfig = {
  type: string
  oauthURL: string
  clientId: string
  redirectUri: string
  scope: string
  accessType: string
  responseType: string
}

export const GOOGLE_OAUTH_CONFIG: OAuthConfig = {
  type: 'Google',
  oauthURL: 'https://accounts.google.com/o/oauth2/auth',
  clientId: OAUTH_CLIENT_IDS.GOOGLE,
  redirectUri: OAUTH_REDIRECT_URIS.GOOGLE,
  scope:
    'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
  accessType: 'offline',
  responseType: 'code',
}

export const FACEBOOK_OAUTH_CONFIG: OAuthConfig = {
  type: 'Facebook',
  oauthURL: 'https://www.facebook.com/dialog/oauth',
  clientId: OAUTH_CLIENT_IDS.FACEBOOK,
  redirectUri: OAUTH_REDIRECT_URIS.FACEBOOK,
  scope: 'email',
  accessType: 'offline',
  responseType: 'code',
}

export function buildOAuthURL(config: OAuthConfig, state: string): string {
  const params = new URLSearchParams({
    client_id: config.clientId,
    redirect_uri: config.redirectUri,
    scope: config.scope,
    access_type: config.accessType,
    response_type: config.responseType,
    state: state,
  })

  return `${config.oauthURL}?${params.toString()}`
}

export function generateOAuthState(moduleId: number = MODULE_IDS.BACKOFFICE, extra: string = ''): string {
  const random = Math.floor(Math.random() * (9999999999 - 1111111111 + 1)) + 1111111111
  return `${moduleId}${random}${extra}`
}
